module.exports = __webpack_public_path__ + "img/pocket bag height.dfdd16f7.png";